import { render, staticRenderFns } from "./secImage.vue?vue&type=template&id=6474c2a2&scoped=true&"
var script = {}
import style0 from "./secImage.vue?vue&type=style&index=0&id=6474c2a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474c2a2",
  null
  
)

export default component.exports